import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { QueryKey } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';

const useDisableHostfullyDevicesModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { disableIntegration } = useDisableIntegrationMutation();

  const openDisableHostfullyDevicesModal = ({
    integrationEnumId,
    queryKey,
  }: {
    integrationEnumId: IntegrationEnum;
    queryKey: QueryKey;
  }) => {
    const handleConfirmDisable = async () => {
      await disableIntegration({
        level: IntegrationMutationLevel.AGENCY,
        enumId: integrationEnumId,
        queryKey,
      });
    };

    openConfirmModal({
      title: t('pageIntegrations.modals.disableHostfullyDevices.title'),
      body: (
        <Alert bsStyle="danger">
          {t('pageIntegrations.modals.disableHostfullyDevices.question')}
        </Alert>
      ),
      confirmLabel: t('common.yes'),
      cancelLabel: t('common.no'),
      cancelColor: 'danger',
      onConfirmAsync: handleConfirmDisable,
    });
  };

  return { openDisableHostfullyDevicesModal };
};

export default useDisableHostfullyDevicesModal;
